<template lang="pug">
.header-principal(ref="headerRef")
  .cc-header__inner.ff-poppins
    nav.navbar.navbar-expand-lg.cc-header__navbar
      router-link.cc-header__brand(:to="{ name: 'cliente-cliente-home' }" aria-label="Ir al inicio")
        img.cc-header__logo(src="../../../assets/LogoColor2.png" title="HIR Casa" alt="HIR Casa")

      span.cc-header__title(v-if="store.titulo && !mostrarMenu") {{ store.titulo }}

      button.navbar-toggler.cc-header__toggler(
        v-if="mostrarMenu"
        type="button"
        data-bs-toggle="collapse"
        :data-bs-target="`#${collapseId}`"
        :aria-controls="collapseId"
        :aria-expanded="isMobileMenuOpen ? 'true' : 'false'"
        aria-label="Abrir menu"
      )
        span.cc-header__toggler-line
        span.cc-header__toggler-line
        span.cc-header__toggler-line

      .collapse.navbar-collapse.cc-header__collapse(
        v-if="mostrarMenu"
        :id="collapseId"
        ref="collapseRef"
      )
        .cc-header__desktop.d-none.d-lg-flex
          .cc-header__nav
            router-link.cc-header__link(
              v-for="link in navLinks"
              :key="link.key"
              :to="{ name: link.name }"
            ) {{ link.label }}

            .cc-header__dropdown(ref="desktopSegurosRef")
              button.cc-header__link.cc-header__link--button(type="button" @click="toggleDesktopSeguros")
                | Seguros
                span.cc-header__chevron(
                  :class="{ 'is-open': isDesktopSegurosOpen }"
                  aria-hidden="true"
                )
                  i.fas.fa-chevron-down
              DsDropdownMenu(v-if="isDesktopSegurosOpen" align="left")
                DsMenuItem(
                  v-for="seguro in seguros"
                  :key="seguro.path"
                  :icon="seguro.icon"
                  :label="seguro.Name"
                  @click="seleccionarSeguro(seguro.path, false)"
                )

          .cc-header__actions
            .cc-header__profile(ref="desktopProfileRef")
              button.cc-header__profile-trigger(type="button" @click="toggleDesktopProfile")
                DsAvatar(:initials="iniciales")
              DsDropdownMenu(v-if="isDesktopProfileOpen" align="right")
                .cc-header__profile-header
                  DsAvatar(:initials="iniciales" size="large")
                  .cc-header__profile-identity
                    span.cc-header__profile-fullname {{ store.nombreCompletoCliente }}
                    span.cc-header__profile-email(v-if="store.correoCliente") {{ store.correoCliente }}

                hr.cc-header__profile-divider

                DsMenuItem(icon="fas fa-user" label="Mi perfil" @click="irAPerfil(false)")
                DsMenuItem(icon="fas fa-bell" :label="`Notificaciones (${notificacionesCount})`" @click="closeDesktopProfile")

                hr.cc-header__profile-divider

                DsMenuItem(icon="fas fa-xmark" label="Cerrar sesion" variant="danger" @click="salir(false)")

        .cc-header__mobile.d-lg-none
          button.cc-header__mobile-profile(type="button" @click="irAPerfil(true)")
            DsAvatar(:initials="iniciales")
            span.cc-header__mobile-profile-name Hola {{ store.nombreCompletoCliente }}
            i.fas.fa-chevron-right

          button.cc-header__mobile-row(type="button" @click="closeMobileMenu")
            i.fas.fa-bell.cc-header__mobile-icon
            span Notificaciones ({{ notificacionesCount }})

          router-link.cc-header__mobile-link(
            v-for="link in navLinks"
            :key="`mobile-${link.key}`"
            :to="{ name: link.name }"
            @click="closeMobileMenu"
          ) {{ link.label }}

          .cc-header__mobile-seguros
            button.cc-header__mobile-link.cc-header__mobile-link--button(type="button" @click="toggleMobileSeguros")
              span Seguros
              span.cc-header__chevron(
                :class="{ 'is-open': mobileSegurosOpen }"
                aria-hidden="true"
              )
                i.fas.fa-chevron-down

            .cc-header__mobile-submenu(v-if="mobileSegurosOpen")
              button.cc-header__mobile-subitem(
                v-for="seguro in seguros"
                :key="`mobile-${seguro.path}`"
                type="button"
                @click="seleccionarSeguro(seguro.path, true)"
              )
                img.cc-header__mobile-subicon(
                  v-if="isImageIcon(seguro.icon)"
                  :src="seguro.icon"
                  alt=""
                  aria-hidden="true"
                )
                i.cc-header__mobile-subicon(v-else :class="seguro.icon")
                span {{ seguro.Name }}

          button.cc-header__mobile-row.cc-header__mobile-row--danger(type="button" @click="salir(true)")
            i.fas.fa-xmark.cc-header__mobile-icon
            span Cerrar sesion

    .cc-header__login-banner(v-if="route.name == 'cliente-cliente-login'")
      router-link.cc-header__beneficiary-link(:to="{ name: 'cliente-cliente-reporte-seguro-vida' }")
        span.cc-header__beneficiary-button Soy beneficiario y quiero reportar un siniestro de vida.
</template>

<script lang="ts" setup>
import * as bootstrap from "bootstrap";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import DsAvatar from "./MaterialApoyo/atoms/DsAvatar.vue";
import DsDropdownMenu from "./MaterialApoyo/atoms/DsDropdownMenu.vue";
import DsMenuItem from "./MaterialApoyo/atoms/DsMenuItem.vue";
import { useDropdown } from "./MaterialApoyo/composables/useDropdown";
import { useLogout } from "./MaterialApoyo/composables/useLogout";
import { useStore } from "../store";
import iconSeguroVida from "../assets/seguros_shield.svg";
import iconSeguroDanios from "../assets/seguros_alarm.svg";
import iconSeguroSiniestros from "../assets/seguros_line.svg";

interface MenuSeguros {
  path: string;
  Name: string;
  icon: string;
}

interface NavLink {
  key: string;
  label: string;
  name: string;
  visible: boolean;
}

const collapseId = "cliente-header-menu";
const originalBodyOverflow = document.body.style.overflow;
const notificacionesCount = 0;

const store = useStore();
const router = useRouter();
const route = useRoute();
const { salir: salirBase } = useLogout();
const headerRef = ref<HTMLElement | null>(null);
const collapseRef = ref<HTMLElement | null>(null);
const desktopProfileRef = ref<HTMLElement | null>(null);
const desktopSegurosRef = ref<HTMLElement | null>(null);
const isMobileMenuOpen = ref(false);
const mobileSegurosOpen = ref(false);
const mostrarTodoSobreMiFinanciamiento = ref(
  import.meta.env.VITE_CLIENTE_CLIENTE_MOSTRAR_TODO_SOBRE_MI_FINANCIAMIENTO == "1"
);
const mostrarMaterialApoyo = ref(import.meta.env.VITE_CLIENTE_CLIENTE_MOSTRAR_MATERIAL_DE_APOYO == "1");
const seguros = ref([] as MenuSeguros[]);

defineProps({
  mostrarMenu: { type: Boolean, default: false }
});

const {
  isOpen: isDesktopProfileOpen,
  toggle: toggleDesktopProfile,
  close: closeDesktopProfile
} = useDropdown("cc-header-profile", desktopProfileRef);

const {
  isOpen: isDesktopSegurosOpen,
  toggle: toggleDesktopSeguros,
  close: closeDesktopSeguros
} = useDropdown("cc-header-seguros", desktopSegurosRef);

const navLinks = computed(() => {
  const links: NavLink[] = [
    { key: "inicio", name: "cliente-cliente-home", label: "Inicio", visible: true },
    { key: "escrituracion", name: "cliente-cliente-escrituracion", label: "Escrituracion", visible: store.mostrarEscrituracion },
    { key: "financiamiento", name: "cliente-cliente-financiamiento", label: "Financiamiento", visible: true },
    { key: "adjudicaciones", name: "cliente-cliente-adjudicaciones", label: "Adjudicaciones", visible: true },
    { key: "material-apoyo", name: "cliente-cliente-materiales-apoyo", label: "Material de apoyo", visible: true },
    { key: "documentos", name: "cliente-cliente-home", label: "Documentos", visible: mostrarTodoSobreMiFinanciamiento.value },
    { key: "material-apoyo-env", name: "cliente-cliente-materiales-apoyo", label: "Material de Apoyo", visible: mostrarMaterialApoyo.value }
  ];

  return links.filter((link) => link.visible);
});

const iniciales = computed(() => {
  const nombre = store.nombreCompletoCliente.trim();
  if (!nombre) return "HC";

  return nombre
    .split(/\s+/)
    .slice(0, 2)
    .map((palabra) => palabra.charAt(0).toUpperCase())
    .join("");
});

function getCollapseInstance() {
  if (!collapseRef.value) return null;
  return bootstrap.Collapse.getOrCreateInstance(collapseRef.value, { toggle: false });
}

function closeDesktopMenus() {
  closeDesktopProfile();
  closeDesktopSeguros();
}

function closeMobileMenu() {
  mobileSegurosOpen.value = false;
  if (window.innerWidth >= 992) return;
  getCollapseInstance()?.hide();
}

function toggleMobileSeguros() {
  mobileSegurosOpen.value = !mobileSegurosOpen.value;
}

function isImageIcon(icon: string) {
  return /\.(svg|png|jpe?g|webp|gif)$/i.test(icon);
}

function updateHeaderHeight() {
  const height = headerRef.value?.getBoundingClientRect().height;
  if (height) {
    collapseRef.value?.style.setProperty("--header-height", `${height}px`);
  }
}

function handleCollapseShown() {
  isMobileMenuOpen.value = true;
  document.body.style.overflow = "hidden";
  updateHeaderHeight();
}

function handleCollapseHidden() {
  isMobileMenuOpen.value = false;
  mobileSegurosOpen.value = false;
  document.body.style.overflow = originalBodyOverflow;
}

async function irAPerfil(cerrarMobile: boolean) {
  closeDesktopProfile();
  if (cerrarMobile) {
    closeMobileMenu();
  }
  await router.push({ name: "cliente-cliente-perfil" });
}

async function salir(cerrarMobile: boolean) {
  closeDesktopMenus();
  if (cerrarMobile) {
    closeMobileMenu();
  }
  await salirBase();
}

async function seleccionarSeguro(periodo: string, cerrarMobile: boolean) {
  closeDesktopSeguros();
  if (cerrarMobile) {
    closeMobileMenu();
  }
  await router.push({ name: periodo });
}

onMounted(() => {
  seguros.value = [
    { path: "cliente-cliente-seguro-vida", Name: "Vida", icon: iconSeguroVida },
    { path: "cliente-cliente-seguro-danios", Name: "Danos", icon: iconSeguroDanios },
    { path: "cliente-cliente-siniestro-generales", Name: "Siniestros", icon: iconSeguroSiniestros }
  ];

  collapseRef.value?.addEventListener("shown.bs.collapse", handleCollapseShown);
  collapseRef.value?.addEventListener("hidden.bs.collapse", handleCollapseHidden);
  window.addEventListener("resize", updateHeaderHeight);
});

onUnmounted(() => {
  collapseRef.value?.removeEventListener("shown.bs.collapse", handleCollapseShown);
  collapseRef.value?.removeEventListener("hidden.bs.collapse", handleCollapseHidden);
  window.removeEventListener("resize", updateHeaderHeight);
  document.body.style.overflow = originalBodyOverflow;
});

watch(() => route.fullPath, () => {
  closeDesktopMenus();
  closeMobileMenu();
});
</script>

<style lang="scss" scoped>
.header-principal {
  position: sticky;
  top: 0;
  z-index: 120;
  background: #ffffff;
  box-shadow: var(--ds-shadow-sm);
  padding: 10px 0;
}

.cc-header__inner {
  max-width: 1208px;
  margin: 0 auto;
  padding: 0 24px;
}

.cc-header__navbar {
  gap: 32px;
  padding: 0;
}

.cc-header__brand {
  flex-shrink: 0;
}

.cc-header__logo {
  height: 48px;
  width: auto;
}

.cc-header__title {
  margin-left: auto;
  font-family: var(--ds-font-family-base);
  font-size: 20px;
  font-weight: 700;
  color: var(--ds-secondary-main);
}

.cc-header__collapse {
  flex-grow: 1;
}

.cc-header__desktop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
}

.cc-header__nav {
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
}

.cc-header__link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  font-family: var(--ds-font-family-base);
  font-size: var(--ds-header-link-size);
  font-weight: var(--ds-subtitle13-weight);
  color: var(--ds-text-primary);
  text-decoration: none;
  border: none;
  background: none;
  cursor: pointer;
  transition: color 0.2s ease;
}

.cc-header__link:hover,
.cc-header__link.router-link-active,
.cc-header__link.router-link-exact-active,
.cc-header__link--button:hover {
  color: var(--ds-primary-main);
}

.cc-header__dropdown {
  position: relative;
}

.cc-header__actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}

.cc-header__profile {
  position: relative;
}

.cc-header__profile-trigger {
  display: flex;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
}

.cc-header__profile-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
}

.cc-header__profile-identity {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.cc-header__profile-fullname,
.cc-header__profile-email {
  color: #000000;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cc-header__profile-divider {
  border: none;
  border-top: 1px solid #bfc0c1;
  margin: 8px 0;
}

.cc-header__chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  font-size: 12px;
  transition: transform 0.2s ease;
}

.cc-header__chevron.is-open {
  transform: rotate(180deg);
}

.cc-header__toggler {
  margin-left: auto;
  padding: 6px;
  border: none;
  background: none;
  box-shadow: none;
}

.cc-header__toggler:focus {
  box-shadow: none;
}

.cc-header__toggler-line {
  display: block;
  width: 24px;
  height: 2px;
  border-radius: 999px;
  background: var(--ds-purple-main);
}

.cc-header__toggler-line + .cc-header__toggler-line {
  margin-top: 5px;
}

.cc-header__mobile {
  display: flex;
  flex-direction: column;
}

.cc-header__mobile-profile {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  background: #f5f5f7;
  border: none;
  cursor: pointer;
  padding: 16px 20px;
  text-align: left;
}

.cc-header__mobile-profile-name {
  flex: 1;
  color: #000000;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
}

.cc-header__mobile-profile i {
  color: var(--ds-secondary-main);
}

.cc-header__mobile-link,
.cc-header__mobile-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 16px 20px;
  border: none;
  border-bottom: 1px solid #e5e5e5;
  background: none;
  color: #000000;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  text-decoration: none;
}

.cc-header__mobile-link.router-link-active,
.cc-header__mobile-link.router-link-exact-active,
.cc-header__mobile-link:hover,
.cc-header__mobile-row:hover {
  color: var(--ds-primary-main);
}

.cc-header__mobile-link--button {
  justify-content: flex-start;
}

.cc-header__mobile-seguros {
  border-bottom: none;
}

.cc-header__mobile-submenu {
  display: flex;
  flex-direction: column;
}

.cc-header__mobile-subitem {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 16px 20px 16px 32px;
  border: none;
  border-top: 1px solid #e5e5e5;
  background: none;
  color: #000000;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
}

.cc-header__mobile-subitem:hover {
  color: var(--ds-primary-main);
}

.cc-header__mobile-subitem:last-child {
  border-bottom: 1px solid #e5e5e5;
}

.cc-header__mobile-icon,
.cc-header__mobile-subicon {
  width: 18px;
  height: 18px;
  min-width: 18px;
  text-align: center;
  color: var(--ds-purple-main);
  object-fit: contain;
}

.cc-header__mobile-row--danger {
  color: #d13237;
  border-bottom: none;
}

.cc-header__mobile-row--danger .cc-header__mobile-icon {
  color: #d13237;
}

.cc-header__login-banner {
  margin-top: 12px;
}

.cc-header__beneficiary-link {
  display: inline-flex;
  text-decoration: none;
}

.cc-header__beneficiary-button {
  display: inline-flex;
  align-items: center;
  border-radius: 20px;
  background: var(--ds-primary-main);
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  padding: 12px 20px;
}

@media (min-width: 992px) {
  .cc-header__collapse {
    display: flex !important;
    align-items: center;
  }
}

@media (max-width: 991.98px) {
  .header-principal {
    z-index: 130;
  }

  .cc-header__navbar {
    gap: 16px;
  }

  .cc-header__collapse {
    position: fixed;
    top: var(--header-height, 68px);
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 125;
    margin-top: 0;
    background: #ffffff;
    overflow-y: auto;
    padding: 0 0 20px;
    box-shadow: 0 18px 30px rgba(20, 19, 49, 0.12);
  }

  .cc-header__inner {
    padding: 0 16px;
  }

  .cc-header__login-banner {
    margin-top: 10px;
  }

  .cc-header__beneficiary-button {
    width: 100%;
    justify-content: center;
    text-align: center;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .header-principal {
    padding: 24px 32px;
  }

  .cc-header__mobile-profile {
    padding: 24px 55px;
    margin-top: 1rem;
  }

  .cc-header__mobile-link,
  .cc-header__mobile-row {
    padding: 32px 16px;
    width: 90%;
    margin: auto;
  }

  .cc-header__mobile-subitem {
    padding: 24px 16px 10px;
    width: 90%;
    margin: auto;
  }

  .cc-header__mobile-seguros {
    border-bottom: none;
  }
}
</style>
